  <div *ngIf="actionModalActive"
    [config]="{ show: true, backdrop: 'static' }"
    bsModal #autoShownModal="bs-modal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-hidden="true">
    <div *ngIf="modalType === 'accept'" class="custom-theme-modal modal-dialog modal-dialog-centered accept-time">
      <div class="modal-content">
        <div class="modal-content-data">
          <div class="slot-desc">
            <h3 class="heading-4">{{mls.languageText.event_modal_text.key1}}</h3>
            <p class="paragraph"><span class="color-grey-700">{{mls.languageText.event_modal_text.key2}}</span></p>
          </div>
          <ul class="available-slots">
            <li class="slot-radios-buttons" *ngFor="let slot of meetingDetail.rescheduleTimeSlots;let i = index">
              <input id="slot-{{i}}" type="radio" [(ngModel)]="slotIdVal" [value]="slot.slotId" name="timeSlot"/>
              <label class="slot-button" for="slot-{{i}}">
                {{(slot.startTime | dateTimezone : slot.timeZone) | date : 'dd MMM yyyy, h:mm a'}} | {{slot.timeZone}}
              </label>
            </li>
          </ul>
        </div>
        <div class="action-buttons">
          <button type="button" (click)="closeModal()" class="btn-design small outline">{{mls.languageText.event_modal_text.key7}}</button>
          <button class="btn-design small filled" (click)="acceptMeeting('from-detail')">{{mls.languageText.event_card_data.key6}}</button>
        </div>
      </div>
    </div>
    <div *ngIf="modalType === 'accept-from-list'" class="custom-theme-modal modal-dialog modal-dialog-centered accept-time">
      <div class="modal-content">
        <div class="modal-content-data">
          <div class="slot-desc">
            <h3 class="heading-4">{{mls.languageText.event_modal_text.key1}}</h3>
            <p class="paragraph"><span class="color-grey-700">{{mls.languageText.event_modal_text.key2}}</span></p>
          </div>
          <ul class="available-slots">
            <li class="slot-radios-buttons" *ngFor="let slot of meeting.rescheduleTimeSlots;let i = index">
              <input id="slot-{{i}}" type="radio" [(ngModel)]="slotIdVal" [value]="slot.slotId" name="timeSlot"/>
              <label class="slot-button" for="slot-{{i}}">
                {{(slot.startTime | dateTimezone : slot.timeZone) | date : 'dd MMM yyyy, h:mm a'}} | {{slot.timeZone}}
              </label>
            </li>
          </ul>
        </div>
        <div class="action-buttons">
          <button type="button" (click)="closeModal()" class="btn-design small outline">{{mls.languageText.event_modal_text.key7}}</button>
          <button class="btn-design small filled" (click)="acceptMeeting()">{{mls.languageText.event_card_data.key6}}</button>
        </div>
      </div>
    </div>
    <div *ngIf="modalType === 'reschedule'" class="custom-theme-modal modal-dialog modal-dialog-centered reschedule-wrapper">
      <div class="modal-content">
        <div class="text-center p-4">
          <div class="slot-desc">
            <h3 class="heading-4 pb-3">{{mls.languageText.event_modal_text.key3}}</h3>
            <p class="paragraph pb-3"><span class="color-grey-700">{{mls.languageText.event_modal_text.key4}}</span></p>
          </div>
          <div class="reschedule-form" *ngIf="rescheduleMeetingData.rescheduleData !== null && rescheduleMeetingData.rescheduleData !== undefined">
              <div class="form-input mb-3">
                <label class="input-label text-left">Preferred Date<span class=" text-danger">*</span></label>
                <app-datepicker (setDate)="setDate($event)" [minDate]="minDate" [dateFor]="'startDate'" [isvalid]="isValidStartDate" [isDisabled]="is_disable_start_date" [plhldr]="'Enter Date'" [errMsg]="'Error in start date'" [dpPlacement]="'bottom'"></app-datepicker>
                <p class="help-block"
                  *ngIf="rescheduleFormSubmitted === true&& !rescheduleDateSelected">
                    Please select a date
                </p>
              </div>
              <div class="form-input text-left mb-3" *ngIf="rescheduleMeetingData.rescheduleData.slot.isSlot === 1">
                <label class="input-label">Preferred Time<span class="color-error">*</span></label>
                <select class="input-field" [(ngModel)]="selectedOption" (change)="selectSlot($event.target.value)">
                  <option [value]="slot.value" *ngFor="let slot of slotsAvailable; let i = index">
                    {{slot.label}}
                  </option>
                </select>
                <p class="help-block"
                  *ngIf="rescheduleFormSubmitted === true&& !rescheduleTimeSlot">
                    Please select a Time Slot
                </p>
              </div>
              <div class="form-input form-textarea mb-3">
                <label class="input-label text-left">Select Reason for Re-Schedule</label>
                <select class="input-field" (change)="selectReason($event.target.value)">
                  <option value="">Select Reason</option>
                  <option [value]="option.id" *ngFor="let option of rescheduleMeetingData.rescheduleData.reasons">{{option.title}}</option>
                </select>
                <textarea
                  *ngIf="!activeCommentForOtherOption"
                  [maxlength]="rescheduleReasonTextLimit"
                  class="mt-2 mb-2 textarea-field"
                  [disabled]="activeCommentForOtherOption"
                  placeholder="Add Comments"
                  [(ngModel)]="commentValue"></textarea>
              </div>
              <div class="mt-4 text-right">
                <button type="button" (click)="closeModal()" class="btn-design medium outline">{{mls.languageText.event_modal_text.key7}}</button>
                <button type="button" class="ml-3 btn-design medium filled" (click)="sendRescheduleRequest()">{{mls.languageText.event_modal_text.key9}}</button>
              </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="modalType === 'decline'" class="custom-theme-modal modal-dialog modal-dialog-centered decline-wrapper">
      <div class="modal-content">
        <div class="text-center p-4">
          <div class="slot-desc">
            <img src="assets/images/webcalendar/decline-cross.svg" alt="icon" />
            <h3 class="heading-4">{{mls.languageText.event_modal_text.key5}}</h3>
            <p class="paragraph"><span class="color-grey-700">{{mls.languageText.event_modal_text.key6}}</span></p>
          </div>
        </div>
        <div class="text-right px-4 pb-4">
          <button type="button" (click)="closeModal('redirectToDetail')" class="btn-design medium outline">
            {{mls.languageText.event_modal_text.key7}}
          </button>
          <button class="ml-3 btn-design medium filled" (click)="declineMeeting()">
            {{mls.languageText.event_modal_text.key8}}
          </button>
        </div>
      </div>
    </div>
  </div>